var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.msg.answerStatus === 0
    ? _c("div", { staticClass: "is-answer-loading" }, [
        _c("div", { staticClass: "is-answer-loading-text" }, [
          _vm._v(_vm._s(_vm.loadingText)),
        ]),
        _vm._m(0),
      ])
    : _vm.msg.answerStatus === 2
    ? _c(
        "div",
        { staticClass: "is-content origin-content" },
        [
          _vm._v("\n  " + _vm._s(_vm.content) + "\n  "),
          _vm.otherSourceAnswer
            ? [
                _c("div", { staticClass: "online-title color-gray-7 mt12" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "pc_biz_ass_lbl_onlineasktitle" /** 我们为您从互联网中找到相关解答： */
                      )
                    )
                  ),
                ]),
                _c("div", {
                  staticClass: "mt4",
                  domProps: { innerHTML: _vm._s(_vm.otherSourceAnswer) },
                }),
              ]
            : _vm._e(),
        ],
        2
      )
    : _c("div", { staticClass: "is-content" }, [
        _vm._v(
          "\n    " +
            _vm._s(
              _vm.content ||
                _vm.settings.assistWele ||
                _vm
                  .$t("pc_biz_ai_question_default_tips")
                  .d("你好，我是AI助手，很高兴为你服务！")
            ) +
            "\n"
        ),
      ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "answer-loading" }, [_c("div")])
  },
]
render._withStripped = true

export { render, staticRenderFns }